import { computed, ref } from 'vue';
const locale = ref('ar');
export function useLanguage() {
    const isArabic = computed(() => locale.value === 'ar');
    const setLocale = (value) => {
        locale.value = value;
        document.documentElement.lang = value;
        document.documentElement.dir = value === 'ar' ? 'rtl' : 'ltr';
    };
    const toggleLocale = () => setLocale(locale.value === 'ar' ? 'en' : 'ar');
    const text = (ar, en) => (isArabic.value ? ar : en);
    return { locale, isArabic, setLocale, toggleLocale, text };
}
